import styled from 'styled-components';

import { BasicButton } from '../../styles/button';

const AddToCartButton = styled(BasicButton).attrs(({ fullWidth = true }) => ({
  fullWidth,
}))`
  min-width: 130px;
`;

/** @component */
export default AddToCartButton;
